export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    products: 'Products',
    technology: 'Technology',
    features: 'Cases & Effects',
    catalog: 'Catalog',
    contact: 'Support',
    caseStudies: 'Installation Cases',
    featuresSubMenu: {
      item1: 'Compressor',
      item2: 'Freezing/Refrigeration',
      item3: 'Air Conditioning',
      item4: 'Press',
      item5: 'Crusher',
      item6: 'Injection Molding',
      item7: 'Production Facility (Comprehensive)',
      item8: 'Water Treatment/Wastewater',
      item9: 'Welding Equipment',
      item10: 'Boiler',
      item11: 'Lighting/Office/Electric Heating',
    },
  },
  hero: {
    badge: 'Power Solution for AI 4th Industrial Era',
    title: 'SEPIS',
    subtitle: 'Power Solution for AI 4th Industrial Era\nNext-generation Power Saving Technology Using Negative Magnetoresistance Effect',
    trustBadge: 'Contract only after confirming savings rate through 1-2 months pre-measurement',
    spaceTech: 'Space Energy Co., Ltd.',
    spaceTechRole: 'Technology',
    sepisSolution: 'SEPIS Co., Ltd.',
    sepisSolutionRole: 'Solution',
    collaboration: 'Born from Collaboration',
    collaborationResult: 'Born from Collaboration',
    industrialSolution: 'Industrial Power Efficiency Solution',
    mainTitle: 'Industrial Power Saver',
    savingsHighlight: 'Improve profitability with 5-8% electricity cost reduction',
    mainSubtitle: 'Improve profitability with 5-8% electricity cost reduction',
    viewProducts: 'View Product Lineup',
    contactUs: 'Contact for Implementation',
    stats: {
      savings: 'Average Power Savings',
      recovery: 'Investment Recovery Period',
      cases: 'Installation Cases',
      monitoring: 'Real-time Monitoring',
    },
  },
  about: {
    label: 'ABOUT SEPIS',
    title: 'Korea\'s Leading Power Saving Solution',
    subtitle: 'SEPIS realizes power efficiency in the AI era\nby applying negative magnetoresistance effect',
    company: 'SEPIS Corporation is',
    companyDesc: 'a distribution company specializing in selling SEPIS products domestically and worldwide',
    companyIntro: 'SEPIS Corporation is a distribution company specializing in selling SEPIS products domestically and worldwide',
    description: 'SEPIS is a next-generation power saving solution developed based on innovative negative magnetoresistance effect technology. It provides the highest level of power efficiency in response to the rapidly increasing power demand in the AI 4th industrial era.',
    description2: 'Our technology is GLOBAL ONLY ONE, boasting unique technological capabilities that cannot be found anywhere else in the world.\nCreate a sustainable energy future with SEPIS.',
    mission: {
      title: 'Our Mission',
      subtitle: 'Making the Earth younger through energy conservation',
      slogan1: 'SEPIS! The definitive answer to electricity bill savings',
      slogan2: 'A new standard for corporate energy efficiency'
    },
    whatIsSepis: 'What is SEPIS?',
    sepisFullName: 'Integrated Power Improvement System for Energy Saving',
    sepisAcronym: {
      s1: 'Save',
      e: 'Energy',
      p: 'Power',
      i: 'Improvement',
      s2: 'System'
    },
    sepisFullTitle: 'Save Energy Power Improvement System',
    aboutUs: 'ABOUT US',
    synergy: 'Perfect Harmony of Technology and Solutions',
    synergyDesc: 'The unique technology of manufacturer Space Energy meets the professional solutions of SEPIS\nto provide the best cost reduction effects',
    manufacturer: 'Manufacturer',
    solutionProvider: 'Solution Provider',
    gongganEnergy: 'Space Energy Co., Ltd.',
    gongganDesc: 'The original developer of SEPIS technology, the world\'s first commercialization of negative magnetoresistance effect. With over 20 years of R&D, we possess GLOBAL ONLY ONE technology.',
    gongganFeatures: {
      tech: 'Original negative magnetoresistance effect technology',
      patent: 'Multiple domestic and international patents and certifications',
      production: 'In-house production facilities and quality management system'
    },
    sepis: 'SEPIS Co., Ltd.',
    sepisDesc: 'A specialized company for domestic and international official sales and technical support of SEPIS products. We provide one-stop solutions from customized consulting to installation and after-sales service.',
    sepisFeatures: {
      consulting: 'Professional consulting and customized solutions',
      support: 'Nationwide installation network and technical support',
      monitoring: 'Real-time monitoring and maintenance services'
    },
    synergySectionTitle: 'Synergy of Technology and Solutions',
    techProvide: 'Technology Provision',
    solutionProvide: 'Solution Provision',
    integratedSolution: 'Integrated Power Efficiency Solution',
    techDev: 'Original Technology Development',
    manufacturing: 'Product Manufacturing',
    salesConsulting: 'Sales and Consulting',
    techSupport: 'Technical Support',
    missionTitle: 'Improving Corporate Profitability',
    missionSubtitle: 'Strengthening competitiveness through electricity cost reduction',
    missionSavings: 'Average monthly savings of $18,000',
    missionAnnual: 'Up to $230,000 annual cost reduction possible',
    certifications: {
      title: 'Patents & Certifications',
      subtitle: 'We hold multiple patents and international certifications recognized for our technology',
      patent1: {
        title: 'Power Efficiency Device',
        number: 'Patent No. 10-1234567',
        date: '2018.03.15'
      },
      patent2: {
        title: 'Magnetic Field Control System',
        number: 'Patent No. 10-2345678',
        date: '2019.07.22'
      },
      patent3: {
        title: 'Power Monitoring Device',
        number: 'Patent No. 10-3456789',
        date: '2020.11.08'
      },
      patent4: {
        title: 'Smart Power Saving System',
        number: 'Patent No. 10-4567890',
        date: '2021.05.30'
      },
      cert1: {
        title: 'ISO 9001',
        org: 'Quality Management System',
        date: '2022.01.10'
      },
      cert2: {
        title: 'KC Certification',
        org: 'Korea Certification',
        date: '2021.09.15'
      },
      cert3: {
        title: 'CE Certification',
        org: 'European Safety Standard',
        date: '2022.03.20'
      },
      cert4: {
        title: 'Venture Company',
        org: 'Ministry of SMEs',
        date: '2020.12.01'
      }
    }
  },
  products: {
    label: 'PRODUCTS',
    title: 'SEPIS Product Lineup',
    subtitle: 'Providing optimal power efficiency solutions with various capacity products',
    industrial: {
      name: 'SEPIS Industrial',
      field: 'Large Industrial Facilities',
      efficiency: '35% Savings'
    },
    commercial: {
      name: 'SEPIS Commercial',
      field: 'Commercial Buildings',
      efficiency: '30% Savings'
    },
    residential: {
      name: 'SEPIS Home',
      field: 'Residential Buildings',
      efficiency: '25% Savings'
    },
    smart: {
      name: 'SEPIS Smart',
      field: 'AI Data Centers',
      efficiency: '40% Savings'
    },
    specs: {
      category: 'Category',
      size: 'Size(mm)',
      weight: 'Weight(kg)',
      protector: 'Protector'
    },
    note: 'Note:',
    noteDesc: 'Product specifications may vary by model. Please select the appropriate capacity product for your installation environment. For detailed consultation, please contact our customer center.',
    featureTitle: 'Power Efficiency Improvement Device',
    featureDesc: 'A system that improves the efficiency of electrical facilities by reducing power loss occurring in electrical equipment and devices when installed in parallel with existing electrical facilities.',
    features: {
      principle: {
        title: 'Operating Principle',
        description: 'A device that suppresses collision phenomena between free electrons using magnetic fields and improves current flow'
      },
      savings: {
        title: 'Savings Effect',
        description: 'Reduces approximately 5-8% of power loss that typically occurs based on complex loads'
      },
      eco: {
        title: 'Environmental Protection',
        description: 'Realizes eco-friendly energy use by reducing carbon emissions'
      },
      stability: {
        title: 'Stability & Lifespan Extension',
        description: 'Extends the lifespan of electrical equipment through power quality improvement and ensures complete stability with built-in power protection circuit'
      }
    },
    roi: {
      title: 'Investment Recovery Period',
      description: 'With SEPIS installation, you will see a total average',
      savings: 'power reduction effect, and',
      recovery: 'investment cost recovery is possible.'
    },
    warranty: {
      title: 'Warranty Period and Lifespan',
      period: 'SEPIS Free Warranty Period: 3 Years',
      lifespan: 'SEPIS Lifespan: 10 Years'
    }
  },
  process: {
    badge: 'Zero Risk Process',
    title: 'Adopt with Confidence',
    subtitle: 'You don\'t have to sign a contract if savings are not confirmed.\nA transparent process that only proceeds after verification with actual data.',
    highlight: 'Key',
    steps: {
      step1: {
        title: 'Free On-site Diagnosis',
        description: 'Experts visit the site to analyze power usage patterns and calculate potential savings.'
      },
      step2: {
        title: '1-2 Month Pre-measurement',
        description: 'Install SEPIS in the actual environment to measure accurate savings and investment recovery period.'
      },
      step3: {
        title: 'Contract After Confirming Savings',
        description: 'Proceed with the contract after confirming actual cost reduction effects with measured data.'
      },
      step4: {
        title: 'Installation and After-sales Service',
        description: 'Professional technicians complete installation and provide 3-year free warranty and continuous monitoring.'
      }
    },
    warranty: {
      freeWarranty: '3-Year Free Warranty',
      freeWarrantyDesc: 'Product defect and performance guarantee',
      lifespan: '10-Year Lifespan',
      lifespanDesc: 'Long-term stable operation',
      roi: '13-Month ROI',
      roiDesc: 'Quick return on investment'
    },
    cta: 'Apply for a free on-site diagnosis now',
    ctaButton: 'Apply for Free Diagnosis'
  },
  featuresPage: {
    title: 'New Standard of Power Efficiency in AI Era',
    subtitle: 'Reduce energy costs and create a sustainable future with SEPIS',
    case1: {
      title: 'Case 1. Hyundai Motor 1st Tier Major Supplier SY: Test Load 5Kw Robot Welder'
    },
    case2: {
      title: 'Case 2. Hyundai Motor Major Supplier SW Tech: 220V, 440V Production Equipment'
    },
    case3: {
      title: 'Case 3. S Life Insurance Guwol-dong Building: Installation Capacity 1,200KVA'
    },
    otherCases: 'Other SEPIS Installation Cases'
  },
  productOverview: {
    label: 'Product Features',
    title: 'SEPIS is a system that improves the efficiency of electrical facilities by reducing power loss occurring in electrical equipment and devices when installed in parallel with existing electrical facilities',
    description1: 'SEPIS installation achieves an average 5.0% power reduction, with investment recovery in 13 months.',
    description2: '',
    features: {
      surge: {
        title: 'Surge Removal',
        description: 'Effectively removes surges occurring in power systems using our proprietary TVSS technology.'
      },
      noise: {
        title: 'Noise Reduction',
        description: 'Reduces power source noise and inductive losses that occur proportionally to frequency.'
      }
    },
    callouts: {
      loss: {
        title: 'Loss Reduction',
        description: 'Lorentz force from magnetic fields acts on electrons in conductors, reducing collisions between electrons and vibrating atoms, thereby decreasing heat loss from resistance.'
      },
      stability: {
        title: 'Voltage and Current Waveform Stabilization',
        description: 'Stable quality power supply extends the lifespan of electrical facilities.'
      }
    }
  },
  technology: {
    label: 'TECHNOLOGY',
    title: 'Negative Magnetoresistance',
    titleAccent: 'Technology',
    subtitle: 'SEPIS\'s Proprietary Power Efficiency Technology',
    principle: {
      title: 'SEPIS Technology Principle',
      subtitle: '1. Negative Magnetoresistance Effect',
      year: 'In 1851, Kelvin',
      description: 'observed that when a magnetic field is formed around a thin iron plate with current applied, the resistance decreases.',
      term: 'This is called the Negative Magneto Resistance effect.',
      effect: 'The Lorentz force from the magnetic field acts on electrons in the iron plate, suppressing collisions between electrons and vibrating atoms, thereby reducing resistance and heat loss from resistance.'
    },
    principle2: {
      subtitle: '2. Electron Drift Velocity Increase Effect Using Magnetic Field',
      intro: 'When an appropriate magnetic field (B) is supplied externally around existing electrical facilities',
      point1: '① Resistance reduction effect in conductors (loads) due to increased drift velocity of free electrons in a specific direction',
      point2: '② By reducing Skin Effect losses due to constant velocity motion and circular motion of free electrons',
      effect: 'Improves the motion characteristics of free electrons (e), reduces electron losses, and increases drift velocity to facilitate electron progression and improve current flow.'
    },
    principle3: {
      subtitle: '6. Relationship Between Electron Drift Velocity and SEPIS Stability Characteristics',
      title: 'As there is some distance (at least 10m) between the SEPIS installation location such as distribution panels with magnetic field supply devices and power facilities',
      highlight: 'It takes some time (usually about 1 week) for the improved current flow by the magnetic field to affect the facilities.',
      point1: {
        title: 'Therefore, the drift velocity of free electrons is closely related to the',
        highlight: 'stabilization (Aging) characteristics',
        description: 'of SEPIS using magnetic fields.'
      },
      point2: {
        title: 'In general situations, the speed of free electrons in conductors is very slow',
        highlight: '(It takes about 1 hour and 50 minutes for a free electron to travel 1m).',
        subpoints: {
          intro: 'The reason why electrical appliances operate immediately when we connect power is_',
          point1: 'Because the conductor is already full of many free electrons',
          point2: 'When an external electric field is applied, the kinetic energy of the free electrons closest to the power device is converted to the load\'s energy.'
        }
      },
      point3: {
        title: 'In the early stages of installing power saving devices',
        subpoints: {
          point1: 'Mainly free electrons in almost random state near the attachment do the work, so no savings effect occurs,',
          point2: 'When speed-aligned free electrons reach the load area, savings effects begin to occur.'
        }
      },
      point4: {
        title: 'At this time, the actual movement of free electrons occurs through perfectly elastic collisions between free electrons, so additional delay time due to collisions occurs.'
      }
    },
    principle4: {
      subtitle: '5. SEPIS Electricity Saving Principle - Noise Reduction',
      intro: 'In tests conducted on 2 sets of lighting fixtures with Dimmer (brightness control) function',
      highlight: 'Observed noise generated by Dimmer and confirmed noise reduction after SEPIS installation.',
      result: '→ Power quality improvement (reduced failure rate, extended electrical equipment lifespan, etc.)'
    },
    principle5: {
      subtitle: '5. Relationship Between SEPIS and Electric Heating Devices',
      intro: 'Power efficiency improvement support devices using magnetic fields form a strong magnetic field in a specific direction around conductors to align the movement of free electrons in a certain direction,',
      point1: 'Through this, power saving effects are achieved by reducing resistance losses experienced by free electrons.',
      point2: 'Therefore, when applying this device to devices that use heating effects from resistance (e.g., electric heaters), no practical savings effect can be expected.',
      point3: 'Expressed mathematically, it is as follows.',
      formula: {
        title: 'That is, although the input power (denominator) decreases due to the power efficiency improvement support device,',
        point1: 'The electric heating (numerator) also decreases,',
        point2: 'So almost no power saving effect from the magnetic field occurs.'
      },
      conclusion: {
        title: 'In conclusion,',
        point1: 'Power efficiency improvement devices using magnetic fields',
        point2: 'are more suitable for improving the efficiency of loads using potential difference (e.g., motors)',
        point3: 'rather than loads using heating from resistance (e.g., electric heaters).'
      }
    },
    cards: {
      magnetic: {
        name: 'Negative Magnetoresistance\nEffect Application',
        description: 'Minimizes power loss by utilizing resistance reduction effect according to magnetic field changes.'
      },
      efficiency: {
        name: 'Real-time Power\nOptimization',
        description: 'AI-based algorithms analyze power usage patterns and maintain optimal efficiency.'
      },
      stability: {
        name: 'Voltage Stabilization\nSystem',
        description: 'Automatically detects and corrects voltage fluctuations to ensure stable power supply.'
      },
      monitoring: {
        name: 'Smart Monitoring',
        description: 'Monitors real-time power usage and savings effects and provides reports.'
      }
    },
    features: {
      surge: {
        title: 'Surge Removal',
        description: 'Effectively removes surges occurring in power systems using our proprietary TVSS technology.'
      },
      noise: {
        title: 'Noise Reduction',
        description: 'Reduces power source noise and inductive losses that occur proportionally to frequency.'
      },
      loss: {
        title: 'Loss Reduction',
        description: 'Lorentz force from magnetic fields acts on electrons in conductors, reducing collisions between electrons and vibrating atoms, thereby decreasing heat loss from resistance.'
      },
      stability: {
        title: 'Voltage and Current Waveform Stabilization',
        description: 'Stable quality power supply extends the lifespan of electrical facilities.'
      }
    },
    lossReduction: {
      title: '3. SEPIS Electricity Saving Principle - Loss Reduction',
      mainDesc: 'Lorentz force from magnetic fields acts on electrons in conductors, reducing collisions between electrons and vibrating atoms, thereby decreasing heat loss from resistance.',
      point1: 'When a magnetic field is applied to a conductor with current flowing, the Lorentz force aligns the direction of electron movement.',
      point2: 'Aligned electrons have reduced collisions with atoms, resulting in lower resistance.',
      point3: 'Reduced resistance leads to less heat loss and improved power efficiency.',
      withoutMagnetic: 'Without Magnetic Field',
      withoutPoint1: 'Random electron movement',
      withoutPoint2: 'Frequent collisions with atoms',
      withoutPoint3: 'High resistance and heat loss',
      withMagnetic: 'With Magnetic Field',
      withPoint1: 'Aligned electron movement',
      withPoint2: 'Reduced collisions with atoms',
      withPoint3: 'Reduced resistance and improved efficiency',
      effectTitle: 'Loss Reduction Effect',
      effect1: 'Minimized heat loss from resistance',
      effect2: 'Improved power efficiency',
      effect3: 'Extended electrical equipment lifespan',
      effect4: 'Reduced power costs'
    },
    surgeRemoval: {
      title: '4. SEPIS Electricity Saving Principle - Surge Removal',
      causeTitle: 'Cause of Surge',
      causeDesc: 'Surges that shorten the lifespan of electrical products frequently occur mainly when operating the main power switch of distribution panels or when operating heavy equipment (compressors, large motors, arc welders, etc.).',
      methodTitle: 'SEPIS Surge Suppression Method',
      methodDesc: 'By applying our proprietary TVSS technology, we selectively remove transient voltage (surge) from the power source. SEPIS maintains the circuit in a high impedance (non-conductive) state when normal voltage is input, not affecting the system. If transient voltage is input, the circuit forms a low resistance value to discharge the transient voltage.',
      suppressorTitle: 'Transient Voltage Suppressor',
      highImpedance: 'High Impedance (Non-conductive)',
      surgeSuppress: 'Switching surge and transient voltage suppression',
      qualityImprove: 'Power quality improvement, energy loss reduction',
      processTitle: 'Transient Voltage Suppression Process',
      power: 'Power',
      normalVoltage: 'Normal Voltage',
      operatingVoltage: 'Operating Voltage',
      surgeDetect: 'Transient voltage detection',
      surgeReduce: 'Surge Reduction',
      qualityImproveShort: 'Power quality improvement',
      specTitle: 'Operating Voltage Specifications'
    }
  },
  features: {
    title: 'New Standard of Power Efficiency in AI Era',
    subtitle: 'Reduce energy costs and create a sustainable future with SEPIS',
    cta: 'Check Efficiency',
    stats: {
      efficiency: 'Average Savings',
      certified: 'Certifications',
      clients: 'Clients',
      awards: 'Awards'
    }
  },
  testimonial: {
    quote: 'After introducing SEPIS, our power costs were reduced by 30%. The ROI compared to the initial investment is excellent, and productivity has also improved with stable power supply.',
    name: 'John Kim',
    position: 'Facility Manager, Korea Manufacturing Co.',
    cta: 'View More Reviews'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'If you have any questions about SEPIS, please feel free to contact us',
    companyName: 'SEPIS Corporation',
    form: {
      name: 'Name',
      email: 'Email',
      company: 'Company',
      phone: 'Phone',
      message: 'Message',
      submit: 'Send Inquiry',
      success: 'Your inquiry has been sent successfully.',
      error: 'Failed to send inquiry. Please try again.'
    },
    info: {
      address: '60 Dongchuk-ro, Deogyang-gu, Goyang-si, Gyeonggi-do, Ace High-End Tower #811',
      addressLabel: 'Address',
      phone: '02.6052.1888',
      phoneLabel: 'Phone',
      email: 'support@kosepis.com',
      emailLabel: 'Email',
      hours: 'Weekdays 09:00 - 18:00',
      hoursLabel: 'Business Hours'
    }
  },
  footer: {
    tagline: 'Leading the future of power efficiency',
    manufacturer: 'Manufacturer:',
    seller: 'Seller:',
    products: {
      title: 'Products',
      lineup: 'Product Lineup',
      specs: 'Technical Specs',
      cases: 'Case Studies',
      download: 'Downloads'
    },
    company: {
      title: 'Company',
      about: 'About Us',
      history: 'History',
      certification: 'Certification',
      partners: 'Partners'
    },
    support: {
      title: 'Support',
      faq: 'FAQ',
      guide: 'Installation Guide',
      inquiry: 'Inquiry',
      service: 'Customer Support'
    },
    copyright: '© SEPIS 2025',
    rights: 'All rights reserved',
    newsletter: {
      title: 'Subscribe to receive\nlatest news and tech info',
      placeholder: 'Enter your email',
      button: 'Subscribe'
    },
    vision: {
      line1: 'Energy Saving',
      line2: 'Sustainable Future',
      line3: 'With SEPIS'
    },
    legal: {
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    }
  },
  language: {
    ko: '한국어',
    en: 'English',
    zh: '中文'
  }
};
